import { ChangeDetectionStrategy, Component, Input, OnDestroy, SimpleChanges } from '@angular/core';
import { RoutingService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';

import { KnBrProductSelectService } from './../../../services/kn-br-product-select.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SALESORG, KnBrProductSalesOrgService } from 'src/app/services/kn-br-product-sales-org.service';
import { MediaComponent } from '@spartacus/storefront';

@Component({
    selector: 'kn-br-product-list-item',
    templateUrl: './kn-br-product-list-item.component.html',
    styleUrls: ['./kn-br-product-list-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MediaComponent]
})
export class KnBrProductListItemComponent implements OnDestroy {
  @Input() product: any;
  @Input() editable: boolean;
  salesOrg: SALESORG = {};
  selectedProductsCodes: string[];
  subscription: Subscription;
  customerContext: string;
  constructor(
    protected productSelectService: KnBrProductSelectService,
    protected routingService: RoutingService,
    protected knBrCustomerContextService: KnBrCustomerContextService,
    protected knBrProductSalesOrgService: KnBrProductSalesOrgService,
    private _sanitizer: DomSanitizer
  ) {
    this.subscription = this.productSelectService.loadSelectedProducts$().subscribe((selectedProductsCodes) => {
      this.selectedProductsCodes = selectedProductsCodes;
    });
    this.subscription.add(
      this.knBrCustomerContextService.getActiveCustomerNumber().subscribe((response) => {
        this.customerContext = response ? response : null;
      })
    );
  }
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.getSalesOrg(this.product.salesOrg);
  }

  getSalesOrg(salesOrg: string) {
    const _salesOrg = this.knBrProductSalesOrgService.getSalesOrgDetails(salesOrg);
    if (_salesOrg) {
      this.salesOrg = _salesOrg;
    }
  }

  getSVGImage(image) {
    return image ? this._sanitizer.bypassSecurityTrustHtml(`${image}`) : '';
  }
  isChecked(code: string): boolean {
    if (this.selectedProductsCodes) {
      return this.selectedProductsCodes.indexOf(code) > -1;
    }
    return false;
  }
  changeCheckBox(event) {
    event.stopPropagation();
    const selectedProductCodes = event.currentTarget.checked ? this.addProductCode() : this.removeProductCode();
    this.productSelectService.setSelectedProducts(selectedProductCodes);
  }
  goToDetail(event) {
    if (event.target && event.target.classList && !event.target.classList.contains('custom-control-input')) {
      event.stopPropagation();
      event.preventDefault();
      location.assign(this.routingService.getFullUrl({ cxRoute: 'product', params: this.product }))
    }
  }
  addProductCode() {
    if (this.selectedProductsCodes && this.selectedProductsCodes.length) {
      this.selectedProductsCodes.push(this.product.code);
    } else {
      this.selectedProductsCodes = [this.product.code];
    }
    return this.selectedProductsCodes;
  }
  removeProductCode() {
    this.selectedProductsCodes.splice(this.selectedProductsCodes.indexOf(this.product.code), 1);
    return this.selectedProductsCodes;
  }
}
